<div class="mobile-lcl-card" [ngClass]="{ 'mobile-lcl-card-denied': isDenied }">
  <div class="mobile-lcl-card__header">
    <div class="mobile-lcl-card__header-reference">
      <span class="label">{{ "SPECIAL_OFFER" | translate }}</span>
      <span class="value">{{ quote?.referenceNumber }}</span>
    </div>
  </div>
  <div class="mobile-lcl-card__route">
    <div class="route-item">
      <div class="circle"></div>
      <div class="departure-line"></div>
      <span>
        <strong>{{ quote?.departurePort?.displayName }}</strong>
        ({{ quote?.departurePort?.unCode }}), {{ quote?.departurePort?.country?.description }}
      </span>
    </div>
    <div class="route-item">
      <div class="circle"></div>
      <div class="arrival-line"></div>
      <span>
        <strong>{{ quote?.arrivalPort?.displayName }}</strong>
        ({{ quote?.arrivalPort?.unCode }}), {{ quote?.arrivalPort?.country?.description }}
      </span>
    </div>
  </div>

  <div class="mobile-lcl-card__packages mb-3">
    <ng-container [ngTemplateOutlet]="quoteTotals"></ng-container>
  </div>

  <div class="mobile-lcl-card__status">
    {{ currentStatusText | translate }}
  </div>
</div>

<ng-template #quoteTotals>
  <div class="d-flex align-items-center justify-content-between">
    <div class="info-block">
      <span class="label">{{ "UNITS" | translate }}:</span>
      <span class="value">{{ quote?.aggregatedStatistics?.totalPackages }}</span>
    </div>
    <div class="info-block">
      <span class="label">{{ "LABELS.WEIGHT" | translate }}</span>
      <span class="value">
        {{ quote?.aggregatedStatistics?.realMeasurements?.totalWeight * KG_TON_MULTIPLIER }} {{ "WEIGHT_UNIT.KG" | translate }}
      </span>
    </div>
    <div class="info-block">
      <span class="label">{{ "LABELS.VOLUME" | translate }}:</span>
      <span class="value">{{ quote?.aggregatedStatistics?.realMeasurements?.totalVolume }} {{ "LABELS.CBM" | translate }}</span>
    </div>
  </div>
</ng-template>
